import React, { FC, ReactNode } from 'react';

export const PlateCollapse: FC<{ children: ReactNode }> = ({ children }) => {
  return <div>{children}</div>;
};
